import { useMemo } from 'react'
import { BaseTable } from 'Features/Projects/Table/BaseTable.view'
import {
  ServiceLevelData,
  UpdateServiceLevelPayload,
} from './ServiceLevel.types'
import { ExtendedGridColDef } from 'Features/Projects/Table/BulkUpdateModal'

interface ServiceLevelTableProps {
  data: ServiceLevelData[]
  isLoading: boolean
  updateTableData: (payload: UpdateServiceLevelPayload[]) => void
  isSaving: boolean
}

export const ServiceLevelTable = ({
  data,
  isLoading,
  updateTableData,
  isSaving,
}: ServiceLevelTableProps) => {
  console.log('Service level table rerenders....!!!')
  const columns: ExtendedGridColDef[] = useMemo(() => {
    return [
      {
        field: 'segment',
        headerName: 'Segment',
        flex: 1,
        type: 'string',
        pinned: 'left',
      },
      {
        field: 'serviceLevel',
        headerName: 'Service level',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value: number) => {
          if (value === null || value === undefined) return ''
          return `${Number(value) * 100}%`
        },
      },
    ]
  }, [])

  const handleUpdateTableData = (
    changedRows: Record<number, ServiceLevelData>
  ) => {
    // Convert BaseTable's changed rows format to our API format
    // changedRows is a Record where keys are row IDs and values are the updated row data
    const updatedData = Object.values(changedRows)
    updateTableData(updatedData)
    // Object.values(changedRows).forEach((row) => {
    //   updateTableData({
    //     segment: row.segment,
    //     serviceLevel: row.serviceLevel,
    //   })
    // })
  }

  return (
    <BaseTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      updateTableData={handleUpdateTableData}
      //uploadData={() => {}}
      isUploading={false}
      isSaving={isSaving}
      checkBoxSelection={true}
      pinnedColumns={['segment']}
    />
  )
}
